module.exports = __webpack_public_path__ + "static/media/clay-banks-Xv.22868e7e.jpg";